import React from "react";
import Box from "@mui/material/Box";

const PinkBar = ({ title, subtitle, pt }) => {
  return (
    <>
      <Box
        sx={{
          pb: 2,
          fontSize: "20px",
          textAlign: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ fontWeight: 600 }}>{title}</Box>
        <Box
          sx={{
            fontSize: "16px",
            paddingTop: "20px",
            color: "#4f5054",
            pt: pt,
          }}
          className="normal"
        >
          {subtitle && <Box>{subtitle}</Box>}
        </Box>
      </Box>

      <Box
        sx={{
          borderBottom: "7px solid #f3756d",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50px",
          textAlign: "center",
        }}
      ></Box>
    </>
  );
};

export default PinkBar;
